import { METHOD_TYPES } from 'utils/constants/index'
import axiosInstanceService, { microServices } from 'network/apis/index'

export const getBlackJackGameBetHistory = (params) => {
  return axiosInstanceService(METHOD_TYPES.get, 'game/fast/blackjack/get-bets', {}, {
    server: microServices.SERVICE_URL_1,
    params
  })
}

export const blackJackGamePlaceBet = ({ data, isDemoGame }) => {
  return axiosInstanceService(METHOD_TYPES.post, 'game/fast/blackjack/place-bet', data, {
    server: microServices.SERVICE_URL_1
    // headers: { 'demo-game': isDemoGame }
  })
}

export const blackJackGameHitBet = ({ data }) => {
  return axiosInstanceService(METHOD_TYPES.post, 'game/fast/blackjack/hit', data, {
    server: microServices.SERVICE_URL_1
    // headers: { 'demo-game': isDemoGame }
  })
}

export const blackJackGameStandBet = () => {
  return axiosInstanceService(METHOD_TYPES.post, 'game/fast/blackjack/stand', {}, {
    server: microServices.SERVICE_URL_1
    // headers: { 'demo-game': isDemoGame }
  })
}

export const blackJackGameDoubleBet = ({ data }) => {
  return axiosInstanceService(METHOD_TYPES.post, 'game/fast/blackjack/place-double-bet', data, {
    server: microServices.SERVICE_URL_1
    // headers: { 'demo-game': isDemoGame }
  })
}

export const blackJackGameSplitBet = ({ data, isDemoGame }) => {
  return axiosInstanceService(METHOD_TYPES.post, 'game/fast/blackjack/place-split-bet', data, {
    server: microServices.SERVICE_URL_1
    // headers: { 'demo-game': isDemoGame }
  })
}

export const blackJackUnfinishedBet = () => {
  return axiosInstanceService(METHOD_TYPES.get, 'game/fast/blackjack/get-unfinished-bet', {}, {
    server: microServices.SERVICE_URL_1
    // headers: { 'demo-game': isDemoGame }
  })
}

export const blackJackPlaceInsuranceBet = ({ data }) => {
  return axiosInstanceService(METHOD_TYPES.post, 'game/fast/blackjack/place-insurance-bet', data, {
    server: microServices.SERVICE_URL_1
    // headers: { 'demo-game': isDemoGame }
  })
}

export const blackJackUpdateCurrentHandStatus = ({ data }) => {
  return axiosInstanceService(METHOD_TYPES.post, 'game/fast/blackjack/update-current-hand-status', data, {
    server: microServices.SERVICE_URL_1
    // headers: { 'demo-game': isDemoGame }
  })
}

export const blackJackCheckFairness = (data) => {
  return axiosInstanceService(METHOD_TYPES.post, 'game/fast/blackjack/check-fairness', data, {
    server: microServices.SERVICE_URL_1
    // headers: { 'demo-game': isDemoGame }
  })
}

export const getMyBlackJackTransactionsService = (params) => {
  return axiosInstanceService(METHOD_TYPES.get, 'game/fast/blackjack/get-my-bets', {}, {
    server: microServices.SERVICE_URL_1,
    params
  })
}

export const getBlackJackHighRollerTransactionsService = (params) => {
  return axiosInstanceService(METHOD_TYPES.get, 'game/fast/blackjack/top-bets', {}, {
    server: microServices.SERVICE_URL_1,
    params
  })
}

export const getBlackJackTransactionsService = (params) => {
  return axiosInstanceService(METHOD_TYPES.get, 'game/fast/blackjack/all-bets', {}, {
    server: microServices.SERVICE_URL_1,
    params
  })
}
